import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformSupportFeedbackIsAllowed } from './support-feedback-is-allowed.transformers';
import { SupportFeedbackIsAllowedCollection } from './support-feedback-is-allowed.types';

const PAYLOAD_TYPE = 'supportFeedbackIsAllowed';

export function supportFeedbackIsAllowedReducer(
  state: CollectionStateSlice<SupportFeedbackIsAllowedCollection> = {},
  action: CollectionActions<SupportFeedbackIsAllowedCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === PAYLOAD_TYPE) {
        const { result, ref, order } = action.payload;

        return mergeDocuments<SupportFeedbackIsAllowedCollection>(
          state,
          transformIntoDocuments(
            [result],
            transformSupportFeedbackIsAllowed,
            ref.path.authUid,
          ),
          order,
          ref,
        );
      }

      return state;
    }

    default:
      return state;
  }
}
